class CompanyLocationApi {
    constructor(fetchService) {
        this.fetchService = fetchService;
    }
    getCompanyLocations({ companyId }) {
        return this.fetchService.get(`/companies/${companyId}/locations`);
    }
}
export default CompanyLocationApi;
